import { apiClient } from '../../../gateways/api'
import type { LeveringStatus } from '../types/LeveringStatus'

export { fetchLeveringen, initialData }

const fetchLeveringen = async (id: string): Promise<LeveringStatus[]> => {
  const { data } = await apiClient({
    url: `/rest/opdracht-hoofdnet/${id}/leveringen`,
    method: 'GET',
  })

  return data
}

const initialData: { data: LeveringStatus[] } = {
  data: [],
}
